import React, { ReactNode } from 'react';
import { useStyles } from './NoticeStyles';
import { Typography } from '../Typography';
import { ClassNameMap } from '@material-ui/styles';
import clsx from 'clsx';
import InfoIcon from '@material-ui/icons/Info';
import { Box } from '@material-ui/core';

interface INotice {
  className?: string;
  heading: string;
  message: string;
  messageType?: 'default' | 'error' | 'info' | unknown;
  children?: ReactNode;
}

export const Notice: React.FC<INotice> = ({ className, heading, message, messageType, children }: INotice): JSX.Element => {
  const classes = useStyles();

  const getNoticeContainerStyles = (messageType: string | unknown, classes: ClassNameMap<string>): string => {
    switch (messageType) {
      case 'default':
        return classes.default;
      case 'info':
        return classes.info;
      case 'error':
        return classes.error;
      default:
        return classes.default;
    }
  };

  const getHeadingIcon = (messageType: string | unknown): ReactNode => {
    switch (messageType) {
      case 'info':
        return <InfoIcon className={classes.headingIconInfo}/>;
      default:
        return <></>;
    }
  };

  return (
    <div className={clsx(className, classes.noticeContainer, getNoticeContainerStyles(messageType, classes))}>
      <Box className={classes.headingContainer}>
        {getHeadingIcon(messageType)}
        <Typography variant="h6">
          {heading}
        </Typography>
      </Box>
      <Typography variant="body2">{message}</Typography>
      {children}
    </div>
  );
};

Notice.defaultProps = {
  messageType: 'default',
};

export default Notice;
